import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function ValueCard({ value, index, isOpen, onToggle }) {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`value-card-${value.key}`}
      onClick={onToggle}
      className={`group relative flex cursor-pointer flex-col items-center border border-white/10 bg-white/[0.015] p-10 text-center transition-all duration-500 hover:border-white/30 md:p-12 ${
        isOpen ? "border-white/30" : ""
      }`}
      style={{
        boxShadow: isOpen ? "0 0 40px rgba(255,255,255,0.06)" : "none",
      }}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
        style={{ boxShadow: "0 0 40px rgba(255,255,255,0.06) inset, 0 0 30px rgba(255,255,255,0.05)" }}
      />

      <div className="flex h-16 w-16 items-center justify-center rounded-full border border-white/20 transition-colors group-hover:border-white/50">
        <span className="font-serif-lux text-2xl font-light text-white/80">{index + 1}</span>
      </div>

      <h3 className="font-serif-lux mt-8 text-3xl font-light tracking-tight text-white md:text-4xl">
        {value.title}
      </h3>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <p className="mx-auto mt-5 max-w-xs text-sm font-light leading-relaxed tracking-wide text-white/60">
              {value.description}
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      <span className="mt-8 text-white/40 transition-colors group-hover:text-white">
        {isOpen ? <Minus size={18} strokeWidth={1} /> : <Plus size={18} strokeWidth={1} />}
      </span>
    </motion.div>
  );
}
